import { api } from '../utils/libs/axios'
import { UpdateAuthUserDto } from '../utils/types/auth'

const getOne = async (id: string) => api(`/v1/users/${id}`)

const update = async ({ id, user }: { id: string; user: UpdateAuthUserDto }) =>
  api.patch(`/v1/users/${id}`, user)

const getNotifications = async (id: string) => api(`/v1/users/${id}/notifications`)

const removeNotification = async ({
  userId,
  submissionId
}: {
  userId: string
  submissionId: string
}) => api.delete(`/v1/users/${userId}/notifications/${submissionId}`)

export const UserService = {
  getOne,
  update,
  getNotifications,
  removeNotification
}
